module.exports = __webpack_public_path__ + "img/edit.0802f29d.svg";